import React from "react";
import { Link } from "react-router-dom";
// import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { IoIosArrowForward } from "react-icons/io";

export default function Resources() {
  return (
    <>
      <div className="py-20 relative z-10">
        <div
          className="flex items-center justify-center gap-7 mb-8"
          style={{ fontFamily: "Philosopher, sans-serif" }}
        >
          <h2 className="text-6xl">
            <span className="text-primary mb-9">Spiritual</span> tools
          </h2>
        </div>
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className=" w-full">
            <div className="grid grid-rows-2 grid-cols-3 gap-12">
              <div className="bg-white rounded-3xl px-7 py-6 row-span-2 shadow-boxshadow2">

                <div
                  className="flex items-center pb-6 mb-6 border-b-2 border-dashed border-gray-500" >
                  <div className="w-[74px] h-[74px]">
                    <img
                      src="./assets/tools/Mantralekhan Icon.svg"
                      alt="daily-darshan"
                      className="mb-4 rounded-2xl overflow-hidden w-[70px] h-[70px] object-cover"
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-xl mb-3">Mantra Lekhan</div>
                    <div className="px-3 py-2 bg-[#FFF5F3] rounded-3xl text-primary">
                      <span>
                        Live Count: <b>10,00,000</b>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mb-4 text-lg">Top 03 Lekhan Rank</div>
                <ul className="text-gray-500 text-lg grid gap-1 list-decimal pl-5">
                  <li>Kalpesh Mangukiya: 5,20,465</li>
                  <li>Dharmesh Ningala: 2,20,465</li>
                  <li>Harshil Pavasiya: 1,20,465</li>
                </ul>
                <div className="flex justify-start mt-6">
                  <Link
                    to="/mantra-lekhan-signin"
                    className="flex items-center px-3 py-1 pt-[5px] bg-[#FFF5F3] rounded-3xl text-primary hover:bg-primary hover:text-white transition-all"
                  >
                    Visit Now <IoIosArrowForward />
                  </Link>
                </div>
              </div>
              {/* <div className='bg-white rounded-3xl shadow-boxshadow2 px-7 py-6'>
                <div className='flex items-center'>
                  <div className='w-[74px] h-[74px] flex justify-center items-center'>
                    <img src='./assets/tools/Photo.svg' alt='daily-darshan' className='mb-2 rounded-2xl overflow-hidden w-[56px] h-[56px] object-cover' />
                  </div>
                  <div className='ml-4'>
                    <div className='text-xl mb-3'>Events Photo Gallery</div>
                    <div className='flex justify-start'><Link className='flex items-center px-3 py-1 pt-[5px] bg-[#FFF5F3] rounded-3xl text-primary hover:bg-primary hover:text-white transition-all'>Visit Now <IoIosArrowForward /></Link></div>
                  </div>
                </div>
              </div> */}
              <div className="bg-white rounded-3xl shadow-boxshadow2 px-7 py-6">
                <div className="flex items-center">
                  <div className="w-[74px] h-[74px]">
                    <img
                      src="./assets/tools/Audio.svg"
                      alt="daily-darshan"
                      className="mb-4 rounded-2xl overflow-hidden w-[64px] h-[64px] object-cover"
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-xl mb-3">Audio Gallery</div>
                    <div className="flex justify-start">
                      <Link
                        to="/audio-album"
                        className="flex items-center px-3 py-1 pt-[5px] bg-[#FFF5F3] rounded-3xl text-primary hover:bg-primary hover:text-white transition-all"
                      >
                        Visit Now <IoIosArrowForward />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-3xl shadow-boxshadow2 px-7 py-6">
                <div className="flex items-center">
                  <div className="w-[74px] h-[74px]">
                    <img
                      src="./assets/tools/Wallpaper.svg"
                      alt="daily-darshan"
                      className="mb-4 rounded-2xl overflow-hidden w-[56px] h-[56px] object-cover"
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-xl mb-3">Wallpapers</div>
                    <div className="flex justify-start">
                      <Link
                        to="/wallpaper"
                        className="flex items-center px-3 py-1 pt-[5px] bg-[#FFF5F3] rounded-3xl text-primary hover:bg-primary hover:text-white transition-all"
                      >
                        Visit Now <IoIosArrowForward />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-3xl shadow-boxshadow2 px-7 py-6">
                <div className="flex items-center">
                  <div className="w-[74px] h-[74px]">
                    <img
                      src="./assets/tools/video.svg"
                      alt="daily-darshan"
                      className="mb-4 rounded-2xl overflow-hidden w-[56px] h-[56px] object-cover"
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-xl mb-3">Videos</div>
                    <div className="flex justify-start">
                      <Link 
                      to="/videos"
                      className="flex items-center px-3 py-1 pt-[5px] bg-[#FFF5F3] rounded-full text-primary hover:bg-primary hover:text-white transition-all">
                        Visit Now <IoIosArrowForward />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <img
          src="/assets/right-line.svg"
          className="absolute right-0 top-24 z-[1px]"
          alt="rightline"
        /> */}
      </div>
    </>
  );
}
